import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import ChevronDownIcon from "@dcl/icons/esm/ui/chevron-down";

var DropdownHeader = function DropdownHeader(_ref) {
  var getClassName = _ref.getClassName,
      text = _ref.text,
      toggleExpand = _ref.toggleExpand,
      a11yHeaderProps = _ref.a11yHeaderProps,
      buttonRef = _ref.buttonRef;
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React.createElement("div", _extends({
      ref: buttonRef
    }, a11yHeaderProps, {
      role: "button",
      className: getClassName({
        descendantName: "header"
      }),
      onClick: toggleExpand
    }), /*#__PURE__*/React.createElement("span", {
      id: "headerText",
      className: getClassName({
        descendantName: "headerText"
      })
    }, text), /*#__PURE__*/React.createElement("span", {
      className: getClassName({
        descendantName: "headerIcon"
      })
    }, /*#__PURE__*/React.createElement(ChevronDownIcon, null)))
  );
};

DropdownHeader.displayName = "DropdownHeader";
export default DropdownHeader;